
import Filter from "../Filter/Filter";
import React from "react";
import SearchPanel from "../SearchPanel";
import '../Filter/Filter.scss';
import { ApolloConsumer } from "@apollo/client";
import InvestorForm from "../InvestorForm/InvestorForm";
//thios ui is refrenced by earlier Buyer screen hence used same class names
export default class InvestorListFilter extends Filter {
    constructor(props) {
        super(props);
        // Create refs using createRef
        this.mainRef = React.createRef();
        this.searchPanelRef = React.createRef();
    }
    close(){
        if (this.searchPanelRef.current) {
            this.searchPanelRef.current.close();
        } else {
            console.warn("SearchPanel ref is not available.");
        }
    };
    render() {
        const { query, paneIndex } = this.state;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
                        <div ref={this.mainRef} className='Filter'>
                            <div className='Filter_content'>
                                {React.cloneElement(this.props.children, { isSuper: this.props.isSuper })}
                            </div>
                            <SearchPanel ref={this.searchPanelRef}>
                                <nav className='Filter_nav'>
                                    <div className='Filter_button' onClick={this.close}>Close</div>
                                </nav>
                                <InvestorForm theme='dark'
                                    data={query}
                                    paneIndex={paneIndex}
                                    isFilter={true}
                                    handleSubmit={this.handleSubmit}
                                    handleCancel={this.clear}
                                    handleParentChange={this.handleChange}
                                    handleParentDropdownChange={this.handleDropdownChange}
                                    handlePaneChange={(key) => this.setState({ paneIndex: key })}
                                />
                            </SearchPanel>
                        </div>
                    )
                }}
            </ApolloConsumer>

        );
    }
}
//#endregion